import Bounce from "react-reveal/Bounce";

export default function SectionOne() {
  const defaultClass = "flex my-auto justify-center";
  return (
    <div className="md:flex md:mb-0 mb-20">
      <Bounce left>
        <div className={`md:w-5/12 ${defaultClass}`}>
          <img
            src={`${window.localhost}/img/logo_creatifa_new.png`}
            className="md:w-4/5 w-10/12"
            alt="Creatifa Studio Banner"
          />
        </div>
      </Bounce>
      <Bounce top>
        <div className={`md:w-7/12 ${defaultClass}`}>
          <img
            src={`${window.localhost}/img/imgsec1.jpg`}
            className="w-4/5"
            alt="Section 1"
          />
        </div>
      </Bounce>
    </div>
  );
}
